module.exports = __webpack_public_path__ + "static/media/web_background_day.1c3eb310.png";